import { useEffect, useState } from 'react'
import { account } from '../../classes/Account'
import { apiURL } from '../../utilities/URLs'
import { refreshAccessToken } from '../../utilities/extensions'
import { useNavigate } from 'react-router-dom'
import ApplicationCard from './components/ApplicationCard'

export default function Dashboard({ impersonationMode, setApplicationId, setProcessorId }) {
  const navigate = useNavigate()
  const [applications, setApplications] = useState([])

  useEffect(() => {
    const handleGetApplications = async () => {
      const applicationsResponse = await fetch(`${apiURL}/api/applications/`, {
        method: 'GET',
        headers: {
          'Authorization': account.accessToken
        }
      })
      const applicationsData = await applicationsResponse.json()
      if (applicationsData.response.error) {
        if (applicationsData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGetApplications() : navigate('/', { state: { expired: true } })
        } else
          console.error(applicationsData.response.error)
      } else
        setApplications(applicationsData.response.applications)
    }

    handleGetApplications()
  }, [])

  return (
    <div className='w-full flex-1 flex flex-col p-4 md:p-8 lg:p-12'>
      <div className='mb-8'>
        <h1 className='text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white mb-2'>Welcome Back, {account.name}</h1>
        <p className='text-slate-500 dark:text-slate-400'>Please select which application you would like to work on.</p>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
        {applications.map((application) => (
          <ApplicationCard key={application.applicationId} _application={application} setApplicationId={setApplicationId} setProcessorId={setProcessorId} />
        ))}
        {impersonationMode && (
          <button onClick={() => navigate('/applications/new')} className='rounded-2xl border-2 border-dashed border-gray-300 dark:border-slate-700 bg-gray-50/50 dark:bg-slate-800/50 flex flex-col items-center justify-center p-6 hover:bg-gray-100 dark:hover:bg-slate-800 hover:border-ertc-primary/50 cursor-pointer transition-all duration-300 group min-h-[120px]'>
            <span className='text-slate-500 dark:text-slate-400 font-medium group-hover:text-ertc-primary transition-colors flex items-center gap-2'>
              <span className='text-2xl'>+</span> Add New Application
            </span>
          </button>
        )}
      </div>
    </div>
  )
}